<div *transloco="let t" [style]="style">
  <div *ngIf="title" style="margin-bottom: 6px;" class="body-xs-semibold"> {{ t(title) }}</div>

  <input [style.border-radius]="borderRadius" (input)="enforceMaxLength($event)" [appUppercase]="isCapitalRequired" [disabled]="disabled" #myInput
    (focus)="moveCursorToEnd()" [type]="type" [nzStatus]="validator?.['status']" [prefix]="prefix"
    [dropSpecialCharacters]="dropSpecialCharacters" [thousandSeparator]="thousandSeparator" [mask]="mask" class="
    body-sm-medium" [value]="value" (input)="onInput($event)" style="height: 48px;" nz-input
    [placeholder]="t(placeholder)" nzSize="large" />

  <div *ngIf="showRemarks === true" class="remark-message"> {{ remark }} </div>
  <div class="error-message"> {{ validator?.['error_message'] === null ? '' : t(validator['error_message']) }} </div>
  <!-- mask="separator.2" thousandSeparator=","   -->
</div>
